import { RetailersNetworksFilter, RetailerNetworkPartialFragment } from '@occc/graphql';

import { useGetRetailerNetworksForUserLazyQuery } from '../../data-access/queries';

export const makeRetailerNetworkFilter = ({
  search,
}: RetailersNetworksFilter): RetailersNetworksFilter => ({
  search: search || null,
});

export const mapRetailerNetworksResponseToRawArray = (
  response: ReturnType<typeof useGetRetailerNetworksForUserLazyQuery>['response'],
) => response.data || [];

export const mapRetailerNetworkToAutocompleteOption = (
  retailerNetwork: RetailerNetworkPartialFragment,
) => ({
  value: retailerNetwork.uuid,
  label: retailerNetwork.name,
  _raw: retailerNetwork,
});
